<div class="modal-body form-modal-body">
  <h4>Results</h4>

  <p>The users have been set up and added to sites as specified</p>
  <p>New users will receive an email with instructions on how to finish setting up their account</p>

  <auto-table [rows]="rows" [cols]="cols"></auto-table>

  <p-footer>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Close</button>
  </p-footer>
</div>
